import { useRoutes } from 'react-router-dom';
import routes from './pages';
import './assets/style/main.scss';

function App() {
  return useRoutes(routes);
}

export default App;
